module.exports = __webpack_public_path__ + "img/double-silver-masters-element.a4bd8996.png";